export default __webpack_public_path__ + "static/media/mobility_arrow_1.9ab31d62.svg";